<template>
    <div>
        <div v-if="status == 0">
            Mengambil data barang, mohon menunggu...
        </div>
        <div v-else-if="status == -1">
            Gagal mengambil data barang.
        </div>
        <div v-else-if="status == 1">
            <h3 id="item-type" class="mb-0">{{ data.type }} <span v-if="data.year != null">({{ data.year }})</span></h3>
            <span id="item-kind">{{ data.kind }}</span> - <span id="item-brand">{{ data.brand }}</span>

            <div v-if="itemFlags.isLMScan">
                <b-row class="mt-2">
                    <b-col md="6">
                        <strong>No. Faktur</strong><br />
                        <span id="no-faktur">{{ data.no_faktur_pgi }}</span>
                    </b-col>
                    <b-col md="6">
                        <strong>Harga Emas</strong> <br />
                        <span>Rp. {{ $helper.formatThousand(data.gold_price) }}</span>
                    </b-col>
                </b-row>
            </div>

            <div v-else>
                <b-row class="mt-2">
                    <b-col md="4">
                        <strong>No. Faktur</strong><br />
                        <span id="no-faktur">{{ data.no_faktur_pgi }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Kadar</strong><br />
                        <span id="imei-sn">{{ data.purity }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Berat Kotor</strong><br />
                        <span id="grade">{{ data.dry_weight }}gr</span>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="4">
                        <strong>Berat Potongan</strong><br />
                        <span id="kelengkapan">{{ data.weight_reduction }}gr</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Ada Cap</strong> <br />
                        <span>{{ hasMark }}</span>
                    </b-col>
                    <b-col md="4" v-if="itemFlags.isPerhiasan">
                        <strong>Jumlah Keping</strong><br />
                        <span id="harga-dasar">{{ data.piece_count }}pcs</span>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="4" v-if="itemFlags.isPerhiasan">
                        <strong>Merk Cap Emas</strong><br />
                        <span id="spek">{{ data.gold_mint_mark }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Berat Bersih</strong> <br />
                        <span>{{ sumNetWeight(data.dry_weight, data.weight_reduction) }} gr</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Harga Emas</strong> <br />
                        <span>Rp. {{ $helper.formatThousand(data.gold_price) }}</span>
                    </b-col>
                </b-row>
                <b-row class="mt-2" v-if="itemFlags.isPerhiasan">
                    <b-col md="4">
                        <strong>Tipe Emas</strong><br />
                        <span id="spek">{{ data.gold_type }}</span>
                    </b-col>
                </b-row>
            </div>

            <b-table bordered hover show-empty no-local-sorting
                :items="invoiceAdjustments"
                :fields="filteredFieldsAdjust"
                responsive class="my-4">
                <template v-slot:empty>
                    Tidak ada adjustment.
                </template>
                <template v-slot:cell(category)="row">
                    {{ row.item.category_name || '-' }}
                </template>
                <template v-slot:cell(name)="row">
                    {{ row.item.name || '-' }}
                </template>
                <template v-slot:cell(adjustment)="row">
                    <b-input-group :prepend="checkAdjustment(row.item).prepend">
                        <b-form-input
                            :value="String(row.item.adjustment).replace('-', '')"
                            :class="checkAdjustment(row.item).class"
                            disabled />
                    </b-input-group>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="d-flex">
                        <b-button size="sm" variant="dark" v-b-tooltip.hover.top title="Gambar Kerusakan"
                            :disabled="isSubmitting"
                            @click="prepareAdjImage(row.item)">
                            <i class="fa fa-fw fa-picture-o" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="dark" v-b-tooltip.hover.top title="Edit Harga"
                            :disabled="isSubmitting || !hasEditAdjPricePermission"
                            @click="editAdjustment(row.item)">
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                        <b-button variant="danger" size="sm" class="ml-2" v-b-tooltip.hover.top title="Hapus"
                            :disabled="isSubmitting || !hasDeleteAdjInventoryPermission"
                            @click="deleteRow(row.item)">
                            <i class="fa fa-fw fa-times" />
                        </b-button>
                    </div>
                </template>
            </b-table>

            <b-row class="my-4" v-if="isAuction">
                <b-col md="4">
                    <b-form-group label="Harga" style="font-weight: 700;">
                        <b-input-group prepend="Rp.">
                            <b-form-input id="input-price" maxlength="50" v-model="goldPrice"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                @input="sanitizeCapital" placeholder="Masukan Harga" />
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="8" v-if="invoiceDetailId">
                    <b-button variant="dark" @click="prepareAddAdjustment" v-if="hasAddAdjInventoryPermission"
                        :disabled="isSubmitting">
                        <i class="fa fa-plus mr-2" />Tambah Keterangan
                    </b-button>
                </b-col>
                <b-col md="12" v-if="!invoiceDetailId" class="text-right">
                    <b-button id="confirm-add-button" variant="primary" @click="confirmAdd" :disabled="isSubmitting">
                        <i class="fa fa-check mr-2" />Lanjutkan
                    </b-button>
                </b-col>
            </b-row>
        </div>

        <!-- Confirm Modal -->
        <b-modal id="m-confirm" size="lg" title="Konfirmasi" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div id="confirmation-text">Konfirmasi {{ invoiceDetailId == null ? 'penambahan' : 'pengubahan' }} barang ini kedalam invoice.</div>
            <b-row class="mt-4">
            <b-col md="4">
                <strong id="confirm-no-faktur-label">No. Faktur</strong><br />
                <span id="confirm-no-faktur">{{ data.no_faktur_pgi }}</span>
            </b-col>
            <b-col md="4" v-if="!isMeltedSale">
                <strong id="confirm-harga-dasar-label">Harga</strong> <br />
                <span id="confirm-harga-dasar">Rp. {{ goldPrice ? goldPrice : $helper.formatThousand(data.gold_price) }}</span>
            </b-col>
            <b-col md="4">
                <strong id="confirm-barang-label">Barang</strong><br />
                <span id="confirm-barang">{{ data.type }} <span v-if="data.year != null">({{ data.year }})</span></span>
            </b-col>
            </b-row>
            <div class="mt-4 text-right">
            <b-button id="confirm-add-button" v-if="invoiceDetailId == null" variant="primary" :disabled="isSubmitting" @click="execAddItem">
                {{ isSubmitting ? "Menambahkan..." : "Tambahkan" }}
            </b-button>
            <b-button id="confirm-edit-button" v-else variant="primary" :disabled="isSubmitting" @click="execEditItem">
                {{ isSubmitting ? "Mengubah..." : "Ubah" }}
            </b-button>
            </div>
        </b-modal>

        <!-- Add Adjustment Modal -->
        <b-modal id="m-add-adjustment-gold" title="Tambah Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Jenis Barang">
                <b-form-select v-model="addAdj.kind" :options="addAdj.optKind" disabled />
            </b-form-group>
            <b-form-group label="Kategori Kerusakan">
                <b-form-select v-model="addAdj.category" :options="optCategory" @input="onChangeAdjCategory" />
            </b-form-group>
            <b-form-group label="Keterangan">
                <b-form-select
                    v-model="addAdj.name"
                    :options="addAdj.optAdjustments"
                    :disabled="$helper.isBlank(addAdj.category) || addAdj.optAdjustments.length <= 0"
                    @change="onSelectAdjustment"
                />
            </b-form-group>
            <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group :prepend="`Rp. ${addAdj.is_increment == 0 ? '-' : ''}`">
                    <b-form-input v-model="addAdj.adjustment" @input="sanitize(addAdj)"
                    :class="{ 'text-danger': addAdj.is_increment == 0,
                                'text-success': addAdj.is_increment == 1,
                             }"
                        :disabled="$helper.isBlank(addAdj.name) || addAdj.hasAdjustmentPrice"
                        maxlength="50" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmAddAdjustment">
                    {{ isSubmitting ? "Menambah..." : "Tambah" }}
                </b-button>
            </div>
        </b-modal>

        <!-- Edit Adjustment Modal -->
        <b-modal id="m-edit-adjustment-gold" title="Edit Harga Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group :prepend="`Rp. ${editAdj.is_increment == 0 ? '-' : ''}`">
                    <b-form-input v-model="editAdj.adjustment" @input="sanitize(editAdj)"
                    :class="{ 'text-danger': editAdj.is_increment == 0,
                                'text-success': editAdj.is_increment == 1,
                             }"
                        maxlength="50" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEditAdjustment">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>

        <!-- Sync Adjustment Confirm Modal -->
        <b-modal id="m-sync-adjustment-confirm-gold" title="Konfirmasi Update Harga Adjustment" centered hide-footer>
            <div>
                Apakah Anda yakin ingin mengupdate harga adjustment dengan data rumus?
            </div>
            <div class="mt-4 text-right">
                <b-button variant="secondary" @click="$bvModal.hide('m-sync-adjustment-confirm-gold')" :disabled="isSubmitting">
                    Batal
                </b-button>
                <b-button variant="primary" class="ml-2" @click="syncAdjustmentPrice" :disabled="isSubmitting">
                    {{ isSubmitting ? "Memproses..." : "Ya, Update" }}
                </b-button>
            </div>
        </b-modal>

        <!-- Damage Image Modal -->
        <b-modal v-if="data.type" id="m-image-gold"
            :title="'Edit Gambar Kerusakan Item ' + data.type + ' (' + activeAdjustment.name + ')'"
            size="xl"
            no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row>
                <b-col cols="12" lg="8">
                    <div class="media-container">
                        <b-img-lazy v-if="mediaPreview.media == 'image'" class="media-preview"
                            :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.computedImageUrl"
                            blank-src="image-loading.gif" block alt="Image Preview"></b-img-lazy>
                        <video v-else-if="mediaPreview.media == 'video'" class="media-preview" controls
                            :key="mediaPreview.url">
                            <source v-if="mediaPreview.type == 'video/webm'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/ogg'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/mp4'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/3gpp'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            Your browser does not support the video tag.
                        </video>
                        <b-img-lazy v-else class="media-preview" src="/img/img-preview.png" block
                            alt="No Image"></b-img-lazy>
                    </div>
                    <div class="media-scroll">
                        <div class="media-scroll-content" v-for="(media, index) in filterMediaList" :key="'ms-' + index"
                            @click="onClickImage(media.urlCompress)">
                            <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }"
                                :src="media.computedImageUrl || '/img/img-loading.gif'"
                                blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="4" class="border-responsive">
                    <b-button block variant="warning" class="mb-2" @click="onRefreshImage()">
                        Refresh
                    </b-button>
                    <span>
                        <b-button
                            block
                            variant="success"
                            @click="triggerFileInputForAdjustment"
                            :disabled="!hasAddPhotoAdjPermission">
                            {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar / Video Baru" }}
                        </b-button>
                        <input
                            type="file"
                            ref="fileInputAdjustment"
                            style="display: none;"
                            accept="image/jpeg, image/png, video/mp4, video/quicktime"
                            @change="uploadFileForAdjustment"
                            multiple
                        />
                    </span>
                    <b-button block variant="primary" class="mt-2"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                        @click="onOpenImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Tampilkan Item di Tab Baru" }}
                    </b-button>
                    <b-button block variant="danger"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting || !hasDeletePhotoAdjPermission"
                        @click="onDeleteImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Hapus Item" }}
                    </b-button>
                    <div class="mt-3 media-disclaimer">
                        <small>*Jenis item gambar yang dapat diterima oleh sistem adalah format JPG, JPEG, dan
                            PNG.</small><br>
                        <small>*Jenis item video yang dapat diterima oleh sistem adalah format MP4, OGG, dan
                            WEBM.</small><br>
                        <small>*Maksimal ukuran total gambar / video untuk sekali upload sebesar 400MB.</small><br>
                        <small>*Minimal jumlah item gambar / video per inventori sebanyak 1 buah item.</small><br>
                        <small>*Maksimal jumlah item gambar / video per inventori sebanyak 10 buah item.</small>
                    </div>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import Uploading from './Uploading.vue'
import LoadingOverlay from './LoadingOverlay.vue'
import EnumPermissions from '@/shared/enum-permissions'
import { groupByDamageType } from '@/shared/damage-types'
import lodash from 'lodash'

export default {
    props: {
        noFaktur: { type: String, required: true },
        invoiceId: { type: Number, required: true },
        invoiceDetailId: { type: Number, default: null },
        invoiceType: { type: String, default: null}
    },
    components: {
        Uploading,
        LoadingOverlay
    },
    data() {
        return {
            status: 0,
            isSubmitting: false,
            data: {},
            inventoryId: null,
            note: "",
            goldPrice: null,

            invoiceAdjustments: [],
            optCategory: [],
            fieldsAdjust: [
                { key: "category", label: "Kategori", sortable: false, thClass: 'adjust-column-min' },
                { key: "name", label: "Keterangan", sortable: false, thClass: 'adjust-column-min' },
                { key: "adjustment", label: "Potongan / Tambahan Harga (Nominal)", sortable: false },
                { key: "action", label: "Aksi" },
            ],

            addAdj: {
                kind: null,
                optKind: [],
                category: null,
                name: null,
                optAdjustments: [],
                adjustment: "",
                hasAdjustmentPrice: false,
                selectedCategoryAdjustments: [],
                is_increment: null,
            },
            editAdj: {
                adjustmentId: null,
                adjustment: "",
                pendingSyncAdjustmentId: null,
                is_increment: null,
            },

            activeAdjustment: {},
            activeAdjustmentRow: null,

            mediaPreview: {},
            mediaList: [],
            isImageChanged: false,
        }
    },
    methods: {
        init() {
            this.status = 0
            this.getItems()
        },

        getItems() {
            let payload = {
                no_faktur_pgi: this.noFaktur,
                invoice_id: this.invoiceId
            }

            if (this.invoiceDetailId != null) {
                payload.invoice_detail_id = this.invoiceDetailId
            }

            this.$axios.post("invoice/get-item-gold", payload).then(res => {
                let data = res.data.data
                this.data = data

                if (this.invoiceDetailId != null) {
                    this.note = data.note
                }

                this.inventoryId = data.inventory_id || data.id || null
                if (this.inventoryId) {
                    this.getInventoryAdjustment(this.inventoryId)
                }
                this.loadCategories()

                this.status = 1
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.status = -1
            })
        },

        loadCategories() {
            if (this.data.kind_id) {
                this.$axios.get("category/selection?item_kind_id=" + this.data.kind_id).then(res => {
                    this.optCategory = res.data.data.map(item => ({
                        value: item.id,
                        text: item.name
                    }))
                }).catch(error => this.$helper.parseError(this, error))
            }
        },

        getInventoryAdjustment(id) {
            this.$axios.get("inventory/get-invoice-adjustments?id=" + id).then(res => {
                this.invoiceAdjustments = res.data.data.map(item => ({
                    adjustment_id: item.adjustments_id,
                    name: item.adjustments_name,
                    adjustment: item.adjustment,
                    adjustmentPercentage: item.adjustment_percentage,
                    category_name: item.category_name,
                    hasAdjFormula: item.has_adj_formula,
                    is_increment: item.is_increment,
                }))

                this.invoiceAdjustments.forEach(adj => this.sanitize(adj, true))
            }).catch(error => this.$helper.parseError(this, error))
        },

        checkAdjustment(item) {
            let val = Number(String(item.adjustment).replace(/\./g, ""))
            let result = {
                class: "",
                prepend: "Rp. "
            }

            if (val == 0) {
                result.class = "text-black"
            } else if (val < 0) {
                result.class = "text-danger"
                result.prepend = "Rp. -"
            } else if (val > 0) {
                result.class = "text-success"
            }
            return result
        },

        prepareAddAdjustment() {
            this.addAdj.optKind = [
                { value: this.data.kind_id, text: this.data.kind }
            ]
            this.addAdj.kind = this.data.kind_id
            this.addAdj.category = null
            this.addAdj.optAdjustments = []
            this.addAdj.name = null
            this.addAdj.adjustment = ""
            this.addAdj.adjustmentPercentage = ""
            this.$bvModal.show("m-add-adjustment-gold")
        },

        onChangeAdjCategory() {
            this.addAdj.name = null
            this.addAdj.optAdjustments = []
            this.addAdj.hasAdjustmentPrice = false
            this.addAdj.adjustment = ""

            if (!this.$helper.isBlank(this.addAdj.category)) {
                let param = "?item_kind_id=" + this.data.kind_id
                param += "&category_id=" + this.addAdj.category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.addAdj.optAdjustments = groupByDamageType(res.data.data.map(item => ({
                        value: item.id,
                        text: item.name,
                        damage_type: item.damage_type
                    })), o => o.damage_type)
                    this.addAdj.selectedCategoryAdjustments = res.data.data
                    this.isSubmitting = false
                })
            }
        },

        onSelectAdjustment(e) {
            const selected = this.addAdj.selectedCategoryAdjustments.find(
                adj => adj.id === e
            )
            const adjPercentages = selected.adjustment_percentages

            this.addAdj.is_increment = selected.is_increment

            if (!adjPercentages) {
                this.addAdj.adjustment = ""
                this.addAdj.hasAdjustmentPrice = false
                return
            }

            const basePrice = this.data.gold_price

            const adjustmentObj = adjPercentages.find(
                range => basePrice >= range.from && basePrice <= range.to
            )

            const adjustmentPrice = adjustmentObj ? adjustmentObj.nominal : null

            if (adjustmentPrice === null) {
                this.addAdj.adjustment = ""
                this.addAdj.hasAdjustmentPrice = false
                return
            }

            let cleaned = String(adjustmentPrice).replace(/\./g, "")
            let res = cleaned.replace(/[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")

            this.addAdj.adjustment = res
            this.addAdj.hasAdjustmentPrice = true
        },

        confirmAddAdjustment() {
            if (this.$helper.isBlank(this.addAdj.name)) {
                this.$helper.toastError(this, "Data Keterangan Adjustment Kerusakan tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.addAdj.adjustment)) {
                this.$helper.toastError(this, "Data Adjustment Nominal tidak boleh kosong!")
                return
            }

            let payload = new FormData()
            payload.append("inventory_id", this.inventoryId)
            payload.append("invoice_detail_id", this.invoiceDetailId)
            payload.append("adjustment_id", this.addAdj.name)
            payload.append("adjustment", this.$helper.toNumber(this.addAdj.is_increment == 0 ? '-' + this.addAdj.adjustment : this.addAdj.adjustment))

            this.isSubmitting = true
            this.$axios.post("invoice/add-invoice-adjustment", payload).then(() => {
                this.getInventoryAdjustment(this.inventoryId)
                this.$bvModal.hide("m-add-adjustment-gold")
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.isSubmitting = false
            })
            .finally(() => this.isSubmitting = false)
        },

        editAdjustment(item) {
            if (item.hasAdjFormula) {
                this.editAdj.pendingSyncAdjustmentId = item.adjustment_id
                this.$bvModal.show('m-sync-adjustment-confirm-gold')
                return
            }
            this.editAdj.adjustmentId = item.adjustment_id
            this.editAdj.adjustment = ""
            this.editAdj.is_increment = item.is_increment
            this.$bvModal.show("m-edit-adjustment-gold")
        },

        confirmEditAdjustment() {
            if (this.$helper.isBlank(this.editAdj.adjustment)) {
                this.$helper.toastError(this, "Data Adjustment Nominal tidak boleh kosong!")
                return
            }

            const payload = {
                invoice_detail_id: this.invoiceDetailId,
                adjustment_id: this.editAdj.adjustmentId,
                adjustment: this.$helper.toNumber(this.editAdj.is_increment == 0 ? '-' + this.editAdj.adjustment : this.editAdj.adjustment)
            }

            this.isSubmitting = true
            this.$axios.patch("invoice/edit-invoice-adjustment", payload).then(() => {
                this.$helper.toastSuccess(this, "Data Adjustment Berhasil Diubah!")
                this.getInventoryAdjustment(this.inventoryId)
                this.$bvModal.hide("m-edit-adjustment-gold")
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        syncAdjustmentPrice() {
            const payload = {
                inventory_id: this.inventoryId,
                adjustment_id: this.editAdj.pendingSyncAdjustmentId
            }

            this.isSubmitting = true
            this.$axios.patch("inventory/sync-adjustment-price", payload).then(() => {
                this.$helper.toastSuccess(this, "Data Adjustment Berhasil Disinkronisasi!")
                this.getInventoryAdjustment(this.inventoryId)
                this.editAdj.pendingSyncAdjustmentId = null
                this.$bvModal.hide("m-sync-adjustment-confirm-gold")
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        deleteRow(item) {
            const isConfirmed = confirm("Apakah Anda yakin ingin menghapus data adjustment ini?")
            if (!isConfirmed) return

            const payload = {
                adjustment_id: item.adjustment_id,
                inventory_id: this.inventoryId
            }

            this.isSubmitting = true
            this.$axios.delete("inventory/delete-invoice-adjustment", { data: payload }).then(() => {
                this.$helper.toastSuccess(this, "Data Adjustment Berhasil Dihapus!")
                this.getInventoryAdjustment(this.inventoryId)
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        prepareAdjImage(item) {
            this.activeAdjustmentRow = item
            this.mediaPreview = {}
            this.mediaList = []
            this.activeAdjustment = item
            this.isSubmitting = true

            let param = "?inventory_id=" + this.inventoryId
            param += "&adjustment_id=" + this.activeAdjustment.adjustment_id

            this.$axios.get("adjustment-damaged-photo" + param).then(res => {
                for (let i = 0; i < res.data.data.length; i++) {
                    let fileMedia = ''
                    let fileAltText = ''
                    if (res.data.data[i].type == 'image/jpeg' || res.data.data[i].type == 'image/png') {
                        fileMedia = 'image'
                        fileAltText = 'Upload Image Preview'
                    }
                    else if (res.data.data[i].type == 'video/mp4' || res.data.data[i].type == 'video/webm' || res.data.data[i].type == 'video/ogg' || res.data.data[i].type == 'video/3gpp') {
                        fileMedia = 'video'
                        fileAltText = 'Upload Video Preview'
                    }
                    else {
                        continue
                    }
                    let filenameSplit = res.data.data[i].path.split('/')
                    filenameSplit = filenameSplit[filenameSplit.length - 1].split('.')
                    let fileExtension = filenameSplit.pop()
                    let filename = filenameSplit.join()
                    this.mediaList.push({
                        id: res.data.data[i].id,
                        media: fileMedia,
                        type: res.data.data[i].type,
                        filename: filename,
                        extension: fileExtension,
                        url: res.data.data[i].path,
                        urlCompress: res.data.data[i].path_compress,
                        altText: fileAltText,
                        status: 'get',
                        isActive: false,
                        file: null
                    })
                }
                this.isImageChanged = false
                this.$bvModal.show("m-image-gold")
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        onClickImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                this.mediaList[i].isActive = false
                if (this.mediaList[i].urlCompress == url) {
                    this.mediaList[i].isActive = true
                    this.mediaPreview = lodash.cloneDeep(this.mediaList[i])
                }
            }
        },

        onOpenImage(url) {
            window.open(url, '_blank')
        },

        onDeleteImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                if (this.mediaList[i].url == url) {
                    if (this.mediaList[i].status == 'get') {
                        this.mediaList[i].status = 'delete'

                        let payload = new FormData()
                        payload.append("inventory_id", this.inventoryId)
                        payload.append("id_photo", this.mediaList[i].id)

                        this.$axios.post("adjustment-damaged-photo/delete", payload).then(() => {
                            this.$helper.toastSuccess(this, "Hapus Gambar Berhasil!")
                        })
                        .catch(error => this.$helper.parseError(this, error))
                    }
                    else {
                        this.mediaList.splice(i, 1)
                    }
                    this.isImageChanged = true
                    break
                }
            }
            this.mediaPreview = {}
        },

        onRefreshImage() {
            this.prepareAdjImage(this.activeAdjustmentRow)
        },

        async setImageSource(media) {
            this.$set(media, 'computedImageUrl', '/img/image-loading.gif')

            let computedUrl

            if (media.media === 'video') {
                computedUrl = '/img/video-thumbnail.png'
            } else if (media.status === 'upload') {
                computedUrl = media.url
            } else {
                const urlCompress = media.urlCompress
                const isUrlCompressAccessible = await this.checkImgUrlStatus(urlCompress)
                computedUrl = isUrlCompressAccessible ? urlCompress : media.url
            }

            this.$set(media, 'computedImageUrl', computedUrl)
        },

        async checkImgUrlStatus(url) {
            return new Promise((resolve) => {
                const img = new Image()
                img.onload = () => resolve(true)
                img.onerror = () => resolve(false)
                img.src = url
            })
        },

        triggerFileInputForAdjustment() {
            this.$refs.fileInputAdjustment.click()
        },

        async uploadFileForAdjustment(event) {
            const files = Array.from(event.target.files)
            if (!files || files.length === 0) return

            const allowedImageTypes = ['image/jpeg', 'image/png']
            const allowedVideoTypes = ['video/mp4', 'video/quicktime']
            const maxSize = 400 * 1024 * 1024
            let totalSize = 0

            for (const file of files) {
                if (!allowedImageTypes.includes(file.type) && !allowedVideoTypes.includes(file.type)) {
                    this.$helper.toastError(this, "Jenis file tidak valid. Silakan unggah gambar (JPG, PNG) atau video (MP4, MOV).")
                    return
                }
                totalSize += file.size
                if (totalSize > maxSize) {
                    this.$helper.toastError(this, "Operasi Save Dibatalkan! Total ukuran gambar / video melebihi kapasitas maksimal 400MB untuk sekali upload.")
                    return
                }
            }

            this.isSubmitting = true

            try {
                const payload = new FormData()
                for (const file of files) {
                    payload.append("url[]", file)
                    payload.append("fileName[]", file.name)
                }

                payload.append("inventory_id", this.inventoryId)
                payload.append("adjustment_id", this.activeAdjustment.adjustment_id)
                payload.append("upload_provider", "local")

                await this.$axios.post("adjustment-damaged-photo/update", payload)

                this.$helper.toastSuccess(this, "Gambar/video berhasil diunggah!")
                this.$bvModal.hide("m-image-gold")
            } catch (error) {
                this.$helper.toastError(this, "Gagal mengunggah media")
            } finally {
                this.isSubmitting = false
            }
        },

        confirmAdd() {
            if (this.isAuction && !this.goldPrice) {
                return this.$helper.toastError(this, "Harga wajib diisi")
            }

            this.$bvModal.show("m-confirm")
        },

        execAddItem() {
            const createPayload = () => {
                const payload = {
                    no_faktur_pgi: this.noFaktur,
                    invoice_id: this.invoiceId,
                    gold_price: this.goldPrice ? this.$helper.toNumber(this.goldPrice) : null,
                    invoice_type: this.invoiceType
                }

                if (!this.$helper.isBlank(this.note)) {
                    payload.note = this.note
                }
                return payload
            }

            const payload = createPayload()
            const url = "invoice/add-item-gold"

            this.isSubmitting = true
            this.$axios
                .post(url, payload)
                .then(res => {
                    this.$bvModal.hide("m-confirm")
                    const info = (res.data && res.data.data && res.data.data.info)
                        ? res.data.data.info
                        : "Barang berhasil ditambahkan!"
                    this.$emit("item-added", info)
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isSubmitting = false
                })
        },

        execEditItem() {
            const createGoldPayload = () => ({
                invoice_detail_id: this.invoiceDetailId,
                gold_price: this.$helper.toNumber(this.goldPrice),
            })

            const payload = createGoldPayload()
            const url = "invoice/edit-item/gold"

            this.isSubmitting = true
            this.$axios
                .post(url, payload)
                .then(() => {
                    this.$bvModal.hide("m-confirm")
                    this.$emit("item-added", "Barang berhasil diubah!")
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isSubmitting = false
                })
        },

        sanitize(item, allowNegative = false) {
            let str = String(item.adjustment)
            let isNegative = str.startsWith("-")

            if (allowNegative && isNegative) {
                str = str.substring(1)
            }

            let cleaned = str.replace(/\./g, "")
            let res = cleaned
                .replace(/[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")

            if (allowNegative && isNegative) {
                res = "-" + res
            }

            item.adjustment = res
        },

        sanitizeCapital() {
            let cleaned = String(this.goldPrice).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.goldPrice = res
        },

        sumNetWeight(dryWeight, weightReduction) {
            return (dryWeight - weightReduction).toFixed(2)
        }
    },
    computed: {
        itemFlags() {
            return {
                isLMRetro: this.data.kind_id === 261,
                isLMScan: this.data.kind_id === 251,
                isPerhiasan: this.data.kind_id === 257,
            }
        },
        hasMark() {
            return this.data.has_mark ? "Ada" : "Tidak Ada"
        },
        isAuction() {
            return this.invoiceType === "AUCTION"
        },
        isOriginalPrice() {
            return this.invoiceType === "ORIGINAL_PRICE"
        },
        isMeltedSale() {
            return this.invoiceType === "MELTED_SALE"
        },
        filteredFieldsAdjust() {
            return this.invoiceDetailId == null
                ? this.fieldsAdjust.filter(field => field.key !== 'action')
                : this.fieldsAdjust
        },
        filterMediaList() {
            return this.mediaList.filter(item => item.status != 'delete')
        },
        hasAddAdjInventoryPermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.ADD_ADJ_INVENTORY.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        hasDeleteAdjInventoryPermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.DELETE_ADJUSTMENT_INVENTORY.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        hasAddPhotoAdjPermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.ADD_FOTO_ADJ.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        hasDeletePhotoAdjPermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.DELETE_FOTO_ADJ.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        hasEditAdjPricePermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.EDIT_ADJUSTMENT_PRICE.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        }
    },
    watch: {
        filterMediaList: {
            handler(newVal) {
                newVal.forEach(media => {
                    if (!media.computedImageUrl) {
                        this.setImageSource(media)
                    }
                })
            },
            deep: true,
            immediate: true
        }
    },
    created() {
        this.init()
    }
}
</script>

<style scoped>
p {
    margin: 0;
}

.adjust-column-min {
    min-width: 200px;
}

.media-container {
    height: 0;
    padding-top: 56.25%;
    position: relative;
}

.media-preview {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    left: 50%;
    transform: translateX(-50%);
}

:not(:root):-webkit-full-screen {
    object-fit: contain !important;
}

.media-scroll {
    margin-top: 10px;
    height: 70px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    background-color: #dee2e6;
    white-space: nowrap;
}

.media-scroll-content {
    display: inline-block !important;
    height: 100%;
    width: 20%;
}

.media-scroll-preview.active {
    border: 5px solid #65c2e4;
}

.media-scroll-preview:hover {
    opacity: 0.5;
}

.media-scroll-preview {
    height: 100%;
    width: 100%;
    border: 5px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    cursor: pointer;
}

.border-responsive {
    margin-top: 10px;
    border-top: 1px solid #c8ced3;
}

.media-disclaimer {
    text-align: justify;
    text-justify: inter-word;
}

@media only screen and (min-width: 576px) {
    .media-scroll {
        height: 100px;
    }
}

@media only screen and (min-width: 992px) {
    .border-responsive {
        margin-top: 0px;
        border-top: none;
        border-left: 1px solid #c8ced3;
    }
}

@media only screen and (min-width: 1200px) {
    .media-scroll {
        height: 150px;
    }
}
</style>
